var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHyper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 -16 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.9522705%",
    y1: "97.5947367%",
    x2: "47.9522705%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC3939",
    offset: "61.3719707%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1BB4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.1805225,4.5 L242.819478,4.5 C247.337456,4.5 251,8.15491795 251,12.6634877 L251,210.336512 C251,214.845082 247.337456,218.5 242.819478,218.5 L13.1805225,218.5 C8.6625447,218.5 5,214.845082 5,210.336512 L5,12.6634877 C5,8.15491795 8.6625447,4.5 13.1805225,4.5 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1748879,14.3496957 L7.1748879,208.932816 C7.1748879,212.893805 10.3890256,216.107623 14.352587,216.107623 L241.647413,216.107623 C245.612928,216.107623 248.825112,212.895803 248.825112,208.932816 L248.825112,14.3496957 C248.825112,10.388706 245.610974,7.1748879 241.647413,7.1748879 L14.352587,7.1748879 C10.3870723,7.1748879 7.1748879,10.3867083 7.1748879,14.3496957 Z M0,14.3496957 C0,6.4245776 6.4240406,0 14.352587,0 L241.647413,0 C249.574128,0 256,6.42669715 256,14.3496957 L256,208.932816 C256,216.857934 249.57596,223.282511 241.647413,223.282511 L14.352587,223.282511 C6.42587205,223.282511 0,216.855814 0,208.932816 L0,14.3496957 Z",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.149126,83.3100265 L114.63569,83.3100265 L114.63569,90.7827535 L76.149126,90.7827535 L76.149126,83.3100265 Z M64.4066385,63.947094 L30.521476,94.3930405 L41.0677202,67.7479265 L26.1813095,57.707641 L60.066472,27.264574 L48.5959027,55.6102185 L64.4066385,63.947094 Z",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyper);
export default __webpack_public_path__ + "static/media/hyper.fcb2630f74796b7316eda0e89f7df97b.svg";
export { ForwardRef as ReactComponent };